import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogHeaderTitle } from '../Dialog/Dialog';
import { __ } from '../../helpers/TranslationService';
import styled from '@emotion/styled';
import { BreakpointsEnum } from '../../helpers/breakpoints';

interface IProps {
    onClose: () => void;
    data: string;
}
const StyledDialog = styled(Dialog)`
    @media (min-width: ${BreakpointsEnum.sm}) {
        max-width: 600px;
    }
`;

export const CabinTariffDialog = (props: IProps) => (
    <StyledDialog open onClose={props.onClose}>
        <DialogHeader>
            <DialogHeaderTitle>{__('tariffDescription', 'dreamlines')}</DialogHeaderTitle>
        </DialogHeader>
        <DialogContent>
            <div dangerouslySetInnerHTML={{ __html: props.data }}></div>
        </DialogContent>
    </StyledDialog>
);
